<template>
    <div class="w-full grid grid-cols-2 items-center gap-1">
        <label :for="id" style="color: var(--label);">{{ label }}</label>
        <input
            :id="id"
            :type="type"
            :placeholder="placeholder"
            class="rounded-md p-1"
            :class="{ 'input-required': isEmptyField() }"
            :value="modelValue"
            @input="$emit('update:modelValue', $event.target.value)"
            />
            <!-- :class="{ 'red-border': isEmptyField('modelValue') }" -->
    </div>
</template>

<script>
export default {
    props: {
        id: String,
        label: String,
        modelValue: String,
        type: {
            type: String,
            default: 'text'
        },
        placeholder: String
    },

    methods: {
        isEmptyField() {
  return (this.modelValue || '').toString().trim() === '';
}
        // j.. 04_04 Troque a fun��o isEmptyField() para trabalhar diretamente com modelValue, e garanta que ele seja tratado como string
        // isEmptyField(field) {
        //     return !this[field] || this[field].trim() === '';
        // }
    },
    
    
    
};
</script>

<style scoped>
</style>
